type ValidationFailedEvent = {
	isViewPage: boolean;
	extensionKey: string;
	error: Error;
};

export const getValidationFailedEvent = ({
	isViewPage,
	extensionKey,
	error,
}: ValidationFailedEvent): {
	type: string;
	data: {
		containerType: string;
		objectType: string;
		source: string;
		action: string;
		actionSubject: string;
		attributes: {
			extensionKey: string;
			message: string;
		};
	};
} => {
	return {
		type: 'sendTrackEvent',
		data: {
			containerType: 'page',
			objectType: 'connectAddon',
			source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
			action: 'failed',
			actionSubject: 'connectRefEventDataValidation',
			attributes: {
				extensionKey,
				message: error.message,
			},
		},
	};
};

export const getReceivedConnectRefDataEvent = ({
	isViewPage,
	extensionKey,
}: {
	isViewPage: any;
	extensionKey: any;
}): {
	type: string;
	data: {
		containerType: string;
		objectType: string;
		source: string;
		action: string;
		actionSubject: string;
		attributes: {
			extensionKey: any;
		};
	};
} => {
	return {
		type: 'sendTrackEvent',
		data: {
			containerType: 'page',
			objectType: 'connectAddon',
			source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
			action: 'received',
			actionSubject: 'connectRefEventData',
			attributes: {
				extensionKey,
			},
		},
	};
};
